import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={toggleTheme}
      title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
      aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
    >
      {theme === 'light' ? '🌙' : '☀️'}
    </button>
  );
};

export const ThemeToggleFixed: React.FC<{ className?: string }> = ({ className = '' }) => (
  <div className={`theme-toggle-corner ${className}`.trim()}>
    <ThemeToggle />
  </div>
);

export default ThemeToggle;






